import React, { useEffect } from "react";

const SmiWidget = ({blockId}) => {
    useEffect(() => {
        (window.smiq = window.smiq || []).push({});
    }, []);

    return <div className="smi24__informer smi24__auto" data-smi-blockid={blockId}></div>;
};

export default SmiWidget;
